import { render } from "./TrainingAnlegenModalComponent.vue?vue&type=template&id=61c10290&scoped=true"
import script from "./TrainingAnlegenModalComponent.vue?vue&type=script&lang=js"
export * from "./TrainingAnlegenModalComponent.vue?vue&type=script&lang=js"

import "./TrainingAnlegenModalComponent.vue?vue&type=style&index=0&id=61c10290&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c10290"]])

export default __exports__